// Portalled menus cannot inherit typography from their field's screen.
export function getDropdownTypography(element, matchSize = true) {
  if (!element?.ownerDocument?.defaultView) return {};

  const style = element.ownerDocument.defaultView.getComputedStyle(element);
  return {
    fontFamily: style.fontFamily,
    ...(matchSize
      ? {
          fontSize: style.fontSize,
          fontWeight: style.fontWeight,
          lineHeight: style.lineHeight,
          letterSpacing: style.letterSpacing,
        }
      : {}),
  };
}

export function getMenuTypography(ownerState = {}) {
  const anchor =
    typeof ownerState.anchorEl === "function"
      ? ownerState.anchorEl()
      : ownerState.anchorEl;
  const fieldSelector = '.MuiSelect-select, [role="combobox"]';
  const field = anchor?.matches?.(fieldSelector)
    ? anchor
    : anchor?.querySelector?.(fieldSelector);
  // Icon buttons use icon sizing; only inherit the surrounding font family.
  const typography = getDropdownTypography(
    field || anchor?.parentElement,
    Boolean(field)
  );
  return {
    ...typography,
    "& .MuiMenuItem-root": {
      ...typography,
      "& .MuiTypography-root": { fontFamily: "inherit" },
    },
  };
}

export function getAutocompleteTypography({ ownerState = {}, anchorEl }) {
  const anchor = typeof anchorEl === "function" ? anchorEl() : anchorEl;
  const field =
    anchor?.querySelector?.("input") ||
    (typeof document === "undefined"
      ? null
      : document.getElementById(ownerState.id));
  const typography = getDropdownTypography(field);
  return {
    ...typography,
    "& .MuiAutocomplete-paper, & .MuiAutocomplete-option, & .MuiAutocomplete-noOptions, & .MuiAutocomplete-loading, & .MuiAutocomplete-groupLabel":
      {
        ...typography,
        "& .MuiTypography-root": { fontFamily: "inherit" },
      },
  };
}
